// extracted by mini-css-extract-plugin
export default {"root":"Button__root--1rA61","root_mobile":"Button__root_mobile--1M2bi","root_blue":"Button__root_blue--3JBjU"};